import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { ApplicationState } from '../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';

import '../styles/core-ui-components.css';
import './StartExperienceGuideComponent.css';

interface StartExperienceGuideComponentState {
    showContent: boolean;
}

interface StartExperienceGuideComponentOwnProps {
    localizedHeader: string;
    renderAsTnSection?: boolean;
    children: React.ReactNode | React.ReactNode[];
}

type ComponentProps = ToxnotComponentProperties &
    RouteComponentProps &
    StartExperienceGuideComponentOwnProps;

// ===============================================================================

class StartExperienceGuideComponent extends ToxnotComponent<ComponentProps, StartExperienceGuideComponentState> {

    // ===============================================================================

    constructor(props: ComponentProps) {
        super(props);

        this.state = {
            showContent: true
        };
    }

    // ===============================================================================

    public render() {
        const renderAsTnSection = this.props.renderAsTnSection ?? false;

        const bodyContent = (
            <React.Fragment>
                <div className="tn-section-row tn-section-heading-row">
                    <div className="tn-section-col-12">
                        <h1>{this.localizeString("Get Started")}</h1>
                    </div>
                </div>
                <div className="tn-section-row">
                    <div className="tn-section-col-12">
                        <div className="start-nav-container">
                            <div className="sidebar">
                                <button type="button" className="btn btn-back" onClick={this.backButton_click}><span className="glyphicon glyphicon-chevron-left"></span></button>
                            </div>
                            <div className="content-container">
                                <div id="get-started-description-and-next-steps-header" className="start-content">
                                    <div className="full-content">
                                        <div className="start-subcontent-heading">
                                            <span>{this.props.localizedHeader}</span>
                                        </div>
                                        {this.state.showContent &&
                                            <div className="start-subcontent-content-container">
                                                {this.props.children}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div>
                                <a onClick={ e => this.toggleContent_click()} role="button"><span className="toggle-get-started-description-and-next-steps-header-content-btn glyphicon glyphicon-minus"></span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );

        if (renderAsTnSection) {
            return (
                <div id="get-started-next-steps-container" className="tn-section">
                    {bodyContent}
                </div>
            );
        }
        else {
            return bodyContent;
        }
    }

    // ===============================================================================

    private backButton_click = () => {
        this.props.history.goBack();
    }

    // ===============================================================================

    private toggleContent_click = () => {
        this.setState({
            showContent: !this.state.showContent
        });
    }
}

// ===============================================================================

export default connect(
    (state: ApplicationState, ownProps: StartExperienceGuideComponentOwnProps) => ({ appServices: state.appServices })
)(withRouter(StartExperienceGuideComponent) as any);
